/**
 * Shows the custom filter drawer if it exists, otherwise just shows the default filter drawer.
 * Clones the filter drawer if it doesn't already exist.
 * Also updates the filter counter and shows/hides the clear filters button.
 */
var cloneDrawer;
function showCustomFilterDrawer() {
  if (cloneDrawer) {
    document.querySelector(".facets-drawer-parent").appendChild(cloneDrawer);
    document.querySelectorAll("form.facets").forEach((form) => {
      form.addEventListener("click", preventFromDoubleClickFilters);
    })
    document.querySelectorAll("#facets-drawer").forEach((element) => {
      element.show();
    });
  } else {
    document.querySelectorAll("#facets-drawer").forEach((element) => {
      element.show();
    });
  }
  countFilters();
}

function countFilters() {
  if (window.location.href.indexOf("?filter") >= 0) {
    document.querySelector('[data-name="filters-counter"]').classList.remove("hidden");
    document.querySelector('[data-name="filters-counter"]').textContent = window.location.href.match(/filter/g).length;
  } else {
    document.querySelector('[data-name="filters-counter"]').textContent = "0";
  }
  setTimeout(() => {
    showAndHideFilterClearBtn();
  }, 1000);
}

function hideOrShowProductTiles() {
  const promoItemsSection = document.querySelector('[data-name="promo-collection"]') ? document.querySelector('[data-name="promo-collection"]') : null;
  if (window.location.href.includes("?filter") || window.location.href.includes("&filter")) {
    if (promoItemsSection) {
      promoItemsSection.classList.add("hidden");
      document.querySelectorAll(".product-tile").forEach((element) => {
        element.parentElement.classList.add("hidden");
      });
    }
  } else {
    if (promoItemsSection) {
      promoItemsSection.classList.remove("hidden");
      document.querySelectorAll(".product-tile").forEach((element) => {
        element.parentElement.classList.remove("hidden");
      });
    }
  }
}

function hideOrShowShopTheLook() {
  const shopTheLookSection = document.querySelector('[data-name="shop-the-look"]') ? document.querySelector('[data-name="shop-the-look"]') : null;
  if (window.location.href.includes("?filter") || window.location.href.includes("&filter")) {
    if (shopTheLookSection) {
      shopTheLookSection.classList.add("hidden");
    }
  } else {
    if (shopTheLookSection) {
      shopTheLookSection.classList.remove("hidden");
    }
  }
}

function showAndHideFilterClearBtn() {
  const filtersClearBtn = document.querySelector('[data-name="js-filter-btn"]');
  if (document.querySelector('[data-name="filters-counter"]').textContent.trim() == "0") {
    filtersClearBtn.classList.add("hidden");
  } else {
    filtersClearBtn.classList.remove("hidden");
  }
}

showAndHideFilterClearBtn();
hideOrShowProductTiles();
hideOrShowShopTheLook();

function preventFromDoubleClickFilters(e) {
  console.log(e.target.tagName);
  if (e.target.tagName === "LABEL") {
    // const inputsContainer = e.target.parentElement;
    const inputsContainers = document.querySelectorAll(".accordion__content");
    inputsContainers.forEach((container) => {
      container.querySelectorAll("label").forEach((input) => {
        input.style.pointerEvents = 'none';
        input.style.opacity = 0.1;
      })
    })
    setTimeout(() => {
      inputsContainers.forEach((container) => {
        container.querySelectorAll("label").forEach((input) => {
          input.style.pointerEvents = 'auto';
          if (input.classList.contains("color-swatch")) {
            input.style.opacity = 1;
          } else {
            input.style.opacity = 0.65;
          }
        })
      })
    }, 1250);
  } else {
    return;
  }
}
document.querySelectorAll("form.facets").forEach((form) => {
  form.addEventListener("click", preventFromDoubleClickFilters);
})

